
import React, { useState, useEffect } from 'react';
import SuperAdminRoot from './pages/dashboard/super/SuperAdminRoot';
import ManagerRoot from './pages/dashboard/manager/ManagerRoot';
import HomePage from './pages/home/HomePage';
import StudentViewPage from './pages/dashboard/manager/studentMember/StudentViewPage';
import { AutoUpdateListener } from './components/common/AutoUpdateListener';

const App: React.FC = () => {
  // Simple routing logic
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  // Check for student-view route
  const studentViewMatch = currentPath.match(/^\/student-view\/(.+)$/);

  return (
    <>
      <AutoUpdateListener />
      {studentViewMatch ? (
        <StudentViewPage memberId={studentViewMatch[1]} />
      ) : (
        <HomePage />
      )}
    </>
  );
};

export default App;
